module.exports = __webpack_public_path__ + "static/media/house-4.f6b51f19.jpg";